import { createContext } from 'react'

import { createContextHook } from '../../../../../../../../lib/utils'
import { ProductColor, ProductFilter } from '../../../../../../../../types/graphql'

export const CollectionFiltersContext = createContext<
  | {
      colors: Record<string, ProductColor>
      filters: ProductFilter[] | undefined
      totalItemsCount: number
    }
  | undefined
>(undefined)

export const useCollectionFiltersContext = createContextHook(
  CollectionFiltersContext,
  'CollectionFiltersContext'
)
